import { addAppInitialForm } from "../../client/Components/Administraton/utils/constant";
import { SET_APP_ROLES, SET_CHECK_ROLE, SET_CREATE_APP_ROLE, SET_IS_CHECK, SET_IS_CHECK_ROLE, SET_REMOVE_APP_ROLE, SET_ROLE, SET_UPDATE_APP_ROLE } from "./types";

const initialState = {
  appRolesData: {
    count: 0,
    data: [],
  },
  isAppRemoved: false,
  role: addAppInitialForm,
  isCheckRole: true,
  checkRole: false,
  isCheck: true,
  addedRoleVal: 0,
  updatedRoleVal: 0
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_APP_ROLES:
      return {
        ...state,
        appRolesData: action.payload,
      };
    case SET_REMOVE_APP_ROLE:
      return {
        ...state,
        isAppRemoved: action.payload,
      }
    case SET_ROLE:
      return {
        ...state,
        role: action.payload
      }
    case SET_CHECK_ROLE:
      return {
        ...state,
        checkRole: action.payload
      }
    case SET_IS_CHECK_ROLE:
      return {
        ...state,
        isCheckRole: action.value,
      };
    case SET_IS_CHECK:
      return {
        ...state,
        isCheck: action.value,
      };
    case SET_CREATE_APP_ROLE:
      return {
        ...state,
        addedRoleVal: action.payload,
      };
    case SET_UPDATE_APP_ROLE:
      return {
        ...state,
        updatedRoleVal: action.payload,
      };
    default:
      return state;
  }
};
export default reducer;
